import { WifiOff } from 'lucide-react';
import { useNetworkStatus } from '@/hooks/useOfflineReport';

export function OfflineBanner() {
  const { isOnline } = useNetworkStatus();

  if (isOnline) return null;

  return (
    <div className="flex items-center gap-2 bg-amber-50 border-b border-amber-300 px-4 py-2 text-sm text-amber-800">
      <WifiOff className="h-4 w-4 flex-shrink-0" />
      <span>
        Bạn đang <strong>offline</strong>. Chỉ có thể xem báo cáo đã được lưu offline trước đó.
      </span>
    </div>
  );
}
